import { Dialog } from "@progress/kendo-react-dialogs";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import InputKendoRct from "../../control-components/input/input";
import Loader from "../../control-components/loader/loader";
import PhoneInputMask from "../../control-components/phone-input-mask/phone-input-mask";
import ErrorHelper from "../../helper/error-helper";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import { AdminService } from "../../services/adminService";

function AddAdmin({ onClose, selectedId }) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [settingError, setSettingError] = useState(false);

  let [fields, setFields] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
  });

  useEffect(() => {
    if (selectedId) {
      getAdminById();
    }
  }, []);

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    var emailPattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (!fields.firstName || fields.firstName.trim().length === 0) {
      formIsValid = false;
      errors["firstName"] = ErrorHelper.FIRST_NAME;
    }
    if (!fields.lastName || fields.lastName.trim().length === 0) {
      formIsValid = false;
      errors["lastName"] = ErrorHelper.LAST_NAME;
    }
    if (!fields.email || fields.email.trim().length === 0) {
      formIsValid = false;
      errors["email"] = ErrorHelper.EMAIL;
    } else if (!emailPattern.test(fields.email)) {
      formIsValid = false;
      errors["email"] = ErrorHelper.INVALID_EMAIL;
    }
    if (!fields.mobile || fields.mobile.trim().length == 0) {
      formIsValid = false;
      errors["mobile"] = ErrorHelper.MOBILE_PHONE;
    } else if (fields.mobile.trim().length != 10) {
      formIsValid = false;
      errors["mobile"] = ErrorHelper.MOBILE_DIGITS;
    }
    setErrors(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const handleValueChange = (e) => {
    const name = e.target.name;
    const rawValue = e.target.rawValue;
    setFields({
      ...fields,
      [name]: rawValue,
    });
  };

  const handleSubmit = (event) => {
    setSettingError(true);
    if (handleValidation()) {
      if (selectedId) {
        updateAdmin();
      } else {
        addAdmin();
      }
    }
  };

  const addAdmin = async () => {
    setLoading(true);
    await AdminService.insertAdmin(fields)
      .then((result) => {
        setLoading(false);
        NotificationManager.success(NOTIFICATION_MESSAGE.ADMINS_ADDED);
        onClose({ updated: true });
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const updateAdmin = async () => {
    setLoading(true);
    await AdminService.updateAdmin(fields, selectedId)
      .then((result) => {
        setLoading(false);
        NotificationManager.success(NOTIFICATION_MESSAGE.ADMINS_UPDATED);
        onClose({ updated: true });
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const getAdminById = async () => {
    setLoading(true);
    await AdminService.getAdminById(selectedId)
      .then((result) => {
        if (result.resultData) {
          setFields({
            ...fields,
            firstName: result.resultData?.firstName,
            lastName: result.resultData?.lastName,
            email: result.resultData?.email,
            mobile: result.resultData?.mobile,
          });
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  return (
    <Dialog
      onClose={onClose}
      title={!selectedId ? "Add Admin User" : "Edit Admin User"}
      className="small-dailog width_90" width={"60%"} height={"auto"}
    >
      <div className="edit-Service-popup dialog-editp y-3 header-blue k-window-title k-dialog-title">
        <div className="mx-3">
          <div className="row align-items-center">
            <div className="col-12 mb-3 mt-3">
              <InputKendoRct
                value={fields.firstName}
                onChange={handleChange}
                name="firstName"
                label="First Name"
                error={fields.firstName == "" && errors.firstName}
                validityStyles={settingError}
                required={true}
                className="form-control"
                placeholder={"First Name"}
              />
            </div>
            <div className="col-12 mb-3">
              <InputKendoRct
                value={fields.lastName}
                onChange={handleChange}
                name="lastName"
                label="Last Name"
                error={fields.lastName == "" && errors.lastName}
                validityStyles={settingError}
                required={true}
                className="form-control"
                placeholder={"Last Name"}
              />
            </div>
            <div className="col-12 mb-3">
              <InputKendoRct
                validityStyles={settingError}
                value={fields.email}
                onChange={handleChange}
                name="email"
                label="Email"
                error={fields.email == "" && errors.email}
                required={true}
                className="form-control"
                placeholder="Email"
              />
            </div>
            <div className="col-12 mb-3">
              <PhoneInputMask
                validityStyles={settingError}
                value={fields.mobile}
                onChange={handleValueChange}
                name="mobile"
                label="Mobile"
                error={fields.mobile === "" && errors.mobile}
                required={true}
                placeholder="Mobile"
              />
            </div>
          </div>
        </div>
        {loading == true && <Loader />}
      </div>

      <div className="border-bottom-line"></div>
      <div className="d-flex my-4">
        <button
          className="green-btn  btn-primary btn-space border-0 mx-3"
          onClick={handleSubmit}
        >
          {!selectedId ? "Add" : "Update"}
        </button>
        <button className="btn grey-secondary btn-space" onClick={onClose}>
          Cancel
        </button>
      </div>
    </Dialog>
  );
}
export default AddAdmin;
